import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#4f46e5' },
    secondary: { main: '#b7f34b' },
    background: { default: '#f5f7fb', paper: '#ffffff' },
    text: { primary: '#121826', secondary: '#667085' },
    success: { main: '#16a675' },
    warning: { main: '#e69a24' },
    error: { main: '#d84c62' }
  },
  typography: {
    fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h4: { fontWeight: 720, letterSpacing: '-0.035em' },
    h5: { fontWeight: 700, letterSpacing: '-0.025em' },
    h6: { fontWeight: 690, letterSpacing: '-0.02em' },
    button: { textTransform: 'none', fontWeight: 650 }
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: { styleOverrides: { root: { borderRadius: 9, boxShadow: 'none' } } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 650, borderRadius: 7 } } }
  }
});
